import Vue from 'vue'
import App from './App.vue'
import store from './store'
import VueAnalytics from 'vue-analytics'

Vue.config.productionTip = false

import 'normalize.css'

Vue.use(VueAnalytics, {
    id: 'UA-119697739-1',
    debug: {
        sendHitTask: true || process.env.NODE_ENV === 'production'
    },
    checkDuplicatedScript: true
})

new Vue({
    store,
    // router,
    render: h => h(App)
}).$mount('#app')
